import { z } from "@core/zod";

import type { OAuthErrorStatus } from "../auth/index.ts";

export const GeneralErrorBodySchema = z.object(
  {
    errorCode: z.string(),
    issues: z.unknown().optional(),
    message: z.string(),
    success: z.literal(false),
    userPresentableMessage: z.string().optional(),
  },
  {
    errorCode: "The name of the response's HTTP status, such as NOT_FOUND",
    issues:
      "The details of the failure, such as the request's validation issues",
    message: "The reason phrase of the response's HTTP status",
    success: "Whether the request succeeded, always false",
    userPresentableMessage: "The message fit to show the user",
  },
);

interface GeneralErrorBody extends z.infer<typeof GeneralErrorBodySchema> {}

interface OAuthErrorBody {
  readonly error: OAuthErrorStatus;
  readonly error_description?: string;
}

export type ApiErrorBody = GeneralErrorBody | OAuthErrorBody;
